/**
 * BookForm component
 * @returns <BookForm />
 */
import { useState } from "react";

import AccordionItem from "./AccordionItem";
import InputCheckBox from "./InputCheckBox";
import InputText from "./InputText";
import Button from "./Button";
import ButtonCard from "./ButtonCard";
import { useNavigate } from "react-router-dom";

import {
    useGetAllBranchesQuery,
    useBookVehicleMutation,
} from "../redux/apiSlice";

import { maskRut } from "../scripts/helpers/masks";

import {
    validateHasValue,
    validatePhoneNumber,
    validateEmail,
    validateRut,
} from "../scripts/helpers/validateFunctions";

const BookForm = (props) => {
    const { totalPrice, productId, dealershipId, payment_type } = props;
    const navigate = useNavigate();
    const [bookVehicle] = useBookVehicleMutation();

    // const {
    //     data: dealerships,
    //     isFetching,
    //     isLoading,
    //     isSuccess,
    //     isError
    // } = useGetAllBranchesQuery();

    const [name, setName] = useState({ value: "", isValid: null, error: null });
    const [phone, setPhone] = useState({
        value: "+56",
        isValid: null,
        error: null,
    });
    const [email, setEmail] = useState({
        value: "",
        isValid: null,
        error: null,
    });
    const [rut, setRut] = useState({ value: "", isValid: null, error: null });
    // const [dealership, setDealership] = useState({ value: "", text: "", isValid: null, error: null });

    const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
        useState(false);
    // const [receiveCommercialInformation, setReceiveCommercialInformation] = useState(false);

    const [personalDataOpen, setPersonalDataOpen] = useState(true);
    // const [dealershipOpen, setDealershipOpen] = useState(true);
    const [paymentType, setPaymentType] = useState(payment_type);

    const personalDataValidity =
        name.isValid && phone.isValid && email.isValid && rut.isValid;
    // const dealershipValidity = dealership.isValid;

    const validatePersonalData = () => {
        console.log("validatePersonalData runs");

        const [isNameValid, nameError] = validateHasValue(name);
        const [isPhoneValid, phoneError] = validatePhoneNumber(phone);
        const [isEmailValid, emailError] = validateEmail(email);
        const [isRutValid, rutError] = validateRut(rut);

        setName((prevState) => {
            return {
                ...prevState,
                isValid: isNameValid,
                error: nameError,
            };
        });

        setPhone((prevState) => {
            return {
                ...prevState,
                isValid: isPhoneValid,
                error: phoneError,
            };
        });

        setEmail((prevState) => {
            return {
                ...prevState,
                isValid: isEmailValid,
                error: emailError,
            };
        });

        setRut((prevState) => {
            return {
                ...prevState,
                isValid: isRutValid,
                error: rutError,
            };
        });

        if (isNameValid && isPhoneValid && isEmailValid && isRutValid) {
            setPersonalDataOpen(!personalDataOpen);
        } else {
            setAcceptTermsAndConditions(false);
        }
    };

    // const dealershipClickHandler = (index) => {
    //     // setDealershipDetails(false)
    //     // setDealershipDetailsOpen(true)
    //     // console.log(index)

    //     setDealership((prevState) => {
    //         return {
    //             ...prevState,
    //             value: index !== prevState.value ? index : null,
    //             isValid: index !== prevState.value ? prevState.isValid : false,
    //         }
    //     })
    // }

    // const isDealershipSelected = () => {
    //     let isValid;
    //     let error;

    //     if (dealership.value !== null && dealership.value !== "") {
    //         console.log("is valid")
    //         isValid = true;
    //         error = null;
    //     } else {
    //         console.log("is invalid")
    //         isValid = false;
    //         error = "Debés seleccionar un concesionario"
    //     }

    //     return [isValid, error];
    // }

    // const validateDealership = () => {
    //     const [isDealerSelected, dealershipError] = isDealershipSelected();

    //     setDealership((prevState) => {
    //         return {
    //             ...prevState,
    //             isValid: isDealerSelected,
    //             error: dealershipError
    //         }
    //     })

    //     if (isDealerSelected) {
    //         setDealershipOpen(!dealershipOpen)
    //     }
    // }

    const webPayDataObject = {
        full_name: name.value,
        rut: rut.value,
        email: email.value,
        phone_number: phone.value,
        branch: Number(dealershipId),
        vehicle: productId,
        payment_type: paymentType,
    };

    const webpayHandler = () => {
        bookVehicle(webPayDataObject)
            .then((res) => {
                window.location.href = res.data.redirect_url;
                // console.log(res.data.redirect_url);
                // navigate(res.data.redirect_url)
            })
            .catch(() => {
                navigate("/error");
            });
    };

    return (
        <div className="book-form">
            <AccordionItem
                type="checkout"
                item={{}}
                accordionItemLabel={"Datos personales"}
                isOpen={personalDataOpen}
                clicked={validatePersonalData}
                isValid={personalDataValidity}
                toggle={() => setPersonalDataOpen(!personalDataOpen)}
            >
                <div className="checkout__input-list">
                    <InputText
                        type={"text"}
                        id={"nombreApellido"}
                        name={"nombreApellido"}
                        label={"Nombre y apellido"}
                        placeholder={"Ingresa tu nombre y apellido"}
                        isRequired={true}
                        changed={(e) => {
                            setName((prevState) => {
                                return {
                                    ...prevState,
                                    value: e.target.value,
                                };
                            });
                        }}
                        disabled={false}
                        error={name.error}
                        value={name.value}
                    />
                    <InputText
                        type={"text"}
                        id={"RUT"}
                        name={"RUT"}
                        label={"RUT"}
                        placeholder={"Ingresa tu RUT"}
                        isRequired={true}
                        disabled={false}
                        changed={(e) => {
                            setRut((prevState) => {
                                return {
                                    ...prevState,
                                    value: maskRut(e.target.value),
                                };
                            });
                        }}
                        error={rut.error}
                        value={rut.value}
                    />

                    <div className="checkout__inputs-group">
                        <InputText
                            type={"text"}
                            id={"correoElectronico"}
                            name={"correoElectronico"}
                            label={"Correo electrónico"}
                            placeholder={"Ingresa tu correo electrónico"}
                            isRequired={true}
                            disabled={false}
                            changed={(e) => {
                                setEmail((prevState) => {
                                    return {
                                        ...prevState,
                                        value: e.target.value,
                                    };
                                });
                            }}
                            // isValid={formState.nombreApellido.isValid}
                            error={email.error}
                            value={email.value}
                        />
                        <InputText
                            type={"text"}
                            id={"telefono"}
                            name={"telefono"}
                            label={"Teléfono"}
                            placeholder={"Ingresa tu teléfono"}
                            isRequired={true}
                            disabled={false}
                            changed={(e) => {
                                setPhone((prevState) => {
                                    return {
                                        ...prevState,
                                        value: e.target.value,
                                    };
                                });
                            }}
                            // isValid={formState.nombreApellido.isValid}
                            error={phone.error}
                            value={phone.value}
                        />
                    </div>
                </div>
            </AccordionItem>

            {/* <AccordionItem type="checkout" item={{}} accordionItemLabel={"Concesionario"} isOpen={dealershipOpen} clicked={() => validateDealership()} isValid={dealershipValidity} toggle={() => setDealershipOpen(!dealershipOpen)} previousSectionValid={personalDataValidity}>
                <InputText
                    type={"text"}
                    id={"concesionario"}
                    name={"concesionario"}
                    label={"Código de vender o asesor de servicio"}
                    placeholder={"Solo si compraste orientado por un asesor de servicio *"}
                    isRequired={false}
                    changed={(e) => {
                        setDealership((prevState) => {
                            return {
                                ...prevState,
                                text: e.target.value
                            }
                        })
                    }}
                    // isValid={formState.nombreApellido.isValid}
                    // error={dealership.error}
                    value={dealership.text}
                    disabled={!personalDataValidity}
                />

                <p className="fw-300 dealership-title">Selecciona el concesionario donde desees realizar la mantencion y/o instalación</p>

                <div className="btn-card__container">
                    {dealerships?.map((dealer, i) => {
                        return (
                            <ButtonCard card={dealer} key={i} clicked={() => dealershipClickHandler(dealer.id)} isSelected={dealer.id === dealership.value} disabled={!personalDataValidity} />
                        )
                    })}
                </div>
            </AccordionItem> */}

            <InputCheckBox
                type={"checkbox"}
                id={"terminosCondiciones"}
                name={"terminosCondiciones"}
                label={"He leído y acepto todos los Términos y Condiciones"}
                value={"acepto-terminos-y-condiciones"}
                isRequired={true}
                changed={() =>
                    setAcceptTermsAndConditions(!acceptTermsAndConditions)
                }
                isChecked={acceptTermsAndConditions}
                extraClass={"checkout__radio"}
                // disabled={accordionsValid ? false : true}
                disabled={!personalDataValidity}
            />
            {/* <InputCheckBox
                type={"checkbox"}
                id={"informacionComercial"}
                name={"informacionComercial"}
                label={"Acepto recibir información comercial."}
                value={"acepto-recibir-informacion-comercial"}
                isRequired={false}
                changed={() => setReceiveCommercialInformation(!receiveCommercialInformation)}
                isChecked={receiveCommercialInformation}
                extraClass={"checkout__radio"}
                // disabled={false}
                disabled={!personalDataValidity}
            /> */}

            <div
                className={`checkout__webpay ${acceptTermsAndConditions ? "--active" : ""
                    }`}
            >
                <p className="purchase-total">
                    El valor de la compra es de ${totalPrice}
                </p>

                <div className="webpay">
                    <p className="fw-300">Pago online vía</p>
                    <img src={`${window._env_.STATIC_HOST}/static/website/images/icon-webpay.svg`} alt="" />
                </div>

                <Button
                    type={"submit"}
                    tag={"cart-with-total-1-line"}
                    text={"Pagar ahora"}
                    hasIcon={true}
                    totalPrice={totalPrice}
                    disabled={!acceptTermsAndConditions}
                    onClick={() => webpayHandler()}
                />
            </div>
        </div>
    );
};

export default BookForm;
